export default {
    delete_cannedcommand_title: "Eliminar los comandos",
    delete_cannedcommand_success_message: "Se ha eliminado el comando",
    delete_cannedcommand_error_message: "No ha sido posible eliminar el comando",
    delete_cannedcommand_label: "¿Está seguro de que quiere eliminar el comando?",
}